var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "row",
        class: _vm.isMobile && "box-sizing availability-calendar-day-main"
      },
      [
        _c(
          "div",
          { staticClass: "d-flex w-100", class: _vm.isMobile && "scroll-h" },
          [
            _c("calendar-return", {
              staticClass: "col-1",
              attrs: { "is-day-selected": !!_vm.selectedDay },
              on: { return: _vm.onReturnSelection }
            }),
            _c(
              "div",
              { staticClass: "d-flex scroll-h" },
              _vm._l(_vm.filterDays, function(day) {
                return _c("calendar-day", {
                  key: day.id,
                  staticClass: "col",
                  class: _vm.isMobile && "scrollable",
                  attrs: {
                    day: day,
                    "is-mobile": _vm.isMobile,
                    selected: day.id === (_vm.selectedDay && _vm.selectedDay.id)
                  },
                  on: { select: _vm.onSelectDay }
                })
              }),
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "col-12 calendar-container px-0",
            class: [
              _vm.isMobile && "p-0",
              _vm.editMode && "border-dashed-orange"
            ],
            attrs: { id: "availability-calendar-container" }
          },
          _vm._l(_vm.hours, function(hour, key) {
            return _c(
              "div",
              {
                key: hour.id,
                staticClass: "d-flex w-100",
                class: _vm.isMobile && "scroll-h"
              },
              [
                _c("calendar-hour", {
                  ref: `calendar-hour-${key}`,
                  refInFor: true,
                  staticClass: "col-1",
                  attrs: {
                    id: `calendar-hour-${key}`,
                    hour: hour,
                    "is-mobile": _vm.isMobile
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "d-flex w-100",
                    class: _vm.isMobile && "scroll-h"
                  },
                  _vm._l(_vm.filterDays, function(day) {
                    return _c(
                      "div",
                      {
                        key: day.id,
                        staticClass: "col px-0 d-flex flex-column"
                      },
                      _vm._l(_vm.quaters, function(q) {
                        return _c(
                          "div",
                          { key: `cell-${day.id}-${hour.id}-${q}` },
                          [
                            _c("calendar-quater", {
                              ref: `quater-item-${day.id}-${hour.id}-${q}`,
                              refInFor: true,
                              attrs: {
                                admission: _vm.admission,
                                "all-data": _vm.quaterData(q, day, hour),
                                day: day,
                                "edit-info": _vm.editInfo,
                                "edit-mode": _vm.editMode,
                                filter: _vm.filter,
                                hour: hour,
                                "is-admission-coordination":
                                  _vm.isAdmissionCoordination,
                                "is-coordination": _vm.isCoordination,
                                "is-mobile": _vm.isMobile,
                                "is-transfer": _vm.isTransfer,
                                "practitioner-id": _vm.practitionerId,
                                quater: q,
                                "selected-day": _vm.selectedDay,
                                "space-list": _vm.spaceList
                              },
                              on: {
                                "add-admission-available-space":
                                  _vm.onAddAdmissionAvailableSpace,
                                "add-available-space": _vm.onAddAvailableSpace,
                                "edit-admission": _vm.onEditAdmission,
                                "remove-admission": _vm.onRemoveAdmission,
                                "show-popper-state": _vm.onShowPopperState
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  }),
                  0
                )
              ],
              1
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }